import PropTypes from 'prop-types';
import { ReportType } from 'reporting-ui-components/types/ReportTypes';
export default {
  report: ReportType.isRequired,
  onDrilldown: PropTypes.func,
  // triggers drilldown modal with supplied report
  setIsRendered: PropTypes.func,
  // callback to indicate a visualization has mounted
  noDataRenderer: PropTypes.func,
  errorRenderer: PropTypes.func,
  renderInVerticalMode: PropTypes.bool,
  disableIframes: PropTypes.bool,
  options: PropTypes.object // deprecated
};